const TOKEN_KEY = 'aqua.token'

export const getToken = () => {
  try { return localStorage.getItem(TOKEN_KEY) } catch { return null }
}
export const setToken = t => {
  try { t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY) } catch { /* private mode */ }
}

export class ApiError extends Error {
  constructor (message, status) {
    super(message)
    this.status = status
  }
}

async function request (method, path, body, { isForm = false } = {}) {
  const headers = {}
  const token = getToken()
  if (token) headers.Authorization = `Bearer ${token}`
  if (body && !isForm) headers['Content-Type'] = 'application/json'

  let res
  try {
    res = await fetch(`/api${path}`, {
      method,
      headers,
      body: body ? (isForm ? body : JSON.stringify(body)) : undefined
    })
  } catch {
    // The API is unreachable — restarting, asleep, no network. This is NOT an
    // auth failure and must never cost the user their session.
    throw new ApiError('Cannot reach the server', 0)
  }

  const text = await res.text()
  let data = null
  try { data = text ? JSON.parse(text) : null } catch { data = { error: text } }

  if (!res.ok) {
    if (res.status === 401) {
      setToken(null)
      // Let the auth provider notice on the next render rather than hard-reloading
      // in the middle of a form submit.
      window.dispatchEvent(new CustomEvent('aqua:signed-out'))
    }
    throw new ApiError(data?.error || `Request failed (${res.status})`, res.status)
  }
  return data
}

export const api = {
  get: (path) => request('GET', path),
  post: (path, body) => request('POST', path, body),
  patch: (path, body) => request('PATCH', path, body),
  put: (path, body) => request('PUT', path, body),
  del: (path) => request('DELETE', path),
  upload: (path, formData) => request('POST', path, formData, { isForm: true })
}

/** Build a query string, dropping empty values. */
export function qs (params) {
  const search = new URLSearchParams()
  for (const [k, v] of Object.entries(params || {})) {
    if (v === null || v === undefined || v === '') continue
    search.set(k, v)
  }
  const s = search.toString()
  return s ? `?${s}` : ''
}
